export const c_table__sticky_cell_InsetInlineStart = {
  "name": "--pf-v6-c-table__sticky-cell--InsetInlineStart",
  "value": "0",
  "var": "var(--pf-v6-c-table__sticky-cell--InsetInlineStart)"
};
export default c_table__sticky_cell_InsetInlineStart;